// Dedicated axios instance for admin endpoints.
// All admin API calls must send the `scah_admin_token` httpOnly cookie,
// so this instance has `withCredentials: true`. Public endpoints continue
// to use the default `axios` import (no credentials), which is required
// for CORS compatibility with the production reverse proxy that returns
// `Access-Control-Allow-Origin: *`.
import axios from "axios";

const adminApi = axios.create({
  withCredentials: true,
});

export default adminApi;
